import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar } from "lucide-react";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";

export default function AdminFeedback() {
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/admin/feedback/recent"); setItems(data); })(); }, []);

  return (
    <AppShell>
      <div className="qv-page-head" data-testid="admin-feedback-page">
        <div className="label">Feedback global</div>
        <h1>Lo que reportan tus jugadores</h1>
        <p className="sub">Últimos feedback recibidos por todos tus clientes, los más recientes primero.</p>
      </div>

      {items.length === 0 ? (
        <div className="qv-empty">Aún no se ha enviado feedback</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {items.map((f) => (
            <div key={f.id} className="qv-card-app">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
                <div>
                  <Link to={`/app/admin/clients/${f.client_id}`} style={{ color: "#fff", fontWeight: 700, textDecoration: "none", fontSize: 16 }}>
                    {f.client_name}
                  </Link>
                  <div style={{ fontSize: 11, color: "#737373", textTransform: "uppercase", letterSpacing: "0.2em", marginTop: 4 }}>
                    <Calendar size={11} style={{ display: "inline", marginRight: 4 }} />
                    {new Date(f.date).toLocaleString("es-ES")}
                    {f.workout_day && <span> · {f.workout_day}</span>}
                  </div>
                </div>
                {f.pain && <span className="qv-pill" style={{ color: "var(--qv-red)", borderColor: "rgba(225,29,46,0.5)" }}>Dolor: {f.pain_zone || "sí"}</span>}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))", gap: 10, marginTop: 14 }}>
                <div className="qv-stat"><div className="lbl">RPE</div><div className="val">{f.rpe}<span className="unit">/10</span></div></div>
                <div className="qv-stat"><div className="lbl">Energía</div><div className="val">{f.energy}<span className="unit">/5</span></div></div>
                <div className="qv-stat"><div className="lbl">Sueño</div><div className="val">{f.sleep_hours}<span className="unit">h</span></div></div>
                <div className="qv-stat"><div className="lbl">Estrés</div><div className="val">{f.stress}<span className="unit">/5</span></div></div>
              </div>
              {f.notes && <div style={{ marginTop: 14, padding: 12, background: "#060606", border: "1px solid rgba(255,255,255,0.05)", fontSize: 13, color: "#cfcfcf" }}>"{f.notes}"</div>}
            </div>
          ))}
        </div>
      )}
    </AppShell>
  );
}
